export const clients: string[] = [
  'Beam Suntory',
  'Kimberly-Clark',
  'Coty',
  'Wella',
  'General Mills',
  'National Beverage',
  'American Licorice',
  'Genpact',
  'Mondelez',
  'Sainsbury',
  'Tesco',
  'AnswerRocket',
];
